import React from 'react';
import { Row, Col } from 'antd';

import { Score } from './Score';
import { Duration } from './Duration';
import { Title } from '@/components/Typography';
import { useCategoryContext } from '../context';
import { RequiredElement } from './RequiredElement';
import { SubCategoryContainer } from '../../styles';
import { OptionalElement } from './OptionalElement';
import { RosaSubCategoryEnum } from '../../../constants';
import type { Element } from '../../../../../hooks/useGetElements';

export function SubCategorySection() {
	const { selectedSubCategory, fieldName, elements } = useCategoryContext();

	const requiredMapper: Record<string, Element> = elements.required.reduce((elementsList, currentElement) => {
		return {
			...elementsList,
			[currentElement.id]: currentElement
		};
	}, {});

	const notRequiredElementsMapper: Record<string, Element> = elements.not_required.reduce(
		(elementsList, currentElement) => {
			return {
				...elementsList,
				[currentElement.name]: currentElement
			};
		},
		{}
	);

	function subCategoryHasDurationField(): boolean {
		const { KEYBOARD, MONITOR, MOUSE, PHONE } = RosaSubCategoryEnum;
		const subCategoriesWithDuration = [KEYBOARD, MONITOR, MOUSE, PHONE];
		const hasDuration = subCategoriesWithDuration.includes(selectedSubCategory.name);
		return hasDuration;
	}

	return (
		<SubCategoryContainer justify="end" gutter={[0, 30]}>
			<Col span={24}>
				<Row justify="space-between" align="middle">
					<Col>
						<Title level={4} style={{ margin: 0 }}>
							{selectedSubCategory.description}
						</Title>
					</Col>
					<Col>
						<Score notRequiredElementsMapper={notRequiredElementsMapper} />
					</Col>
				</Row>
			</Col>
			<Col span={24}>
				<RequiredElement requiredMapper={requiredMapper} />
			</Col>
			<Col span={24}>
				<Row justify="center" gutter={[20, 0]}>
					{elements?.not_required.map((item) => {
						return (
							<OptionalElement
								key={item.id}
								elementProps={item}
								name={[...fieldName, 'not_required', item.name]}
							/>
						);
					})}
				</Row>
			</Col>
			{subCategoryHasDurationField() && (
				<Col lg={12} xl={10} xxl={8}>
					<Duration />
				</Col>
			)}
		</SubCategoryContainer>
	);
}
